export default {  
    "dlabel_upload": "Upload",
    "dlabel_view": "View",
    "dlabel_edit": "Edit",
    "dlabel_delete": "Delete",
    "dlabel_delete_upload": "Delete upload",
    "dlabel_display_file": "Display File",
    "dlabel_dd_img": "Drag and drop the image here!",
    "dlabel_status": "Status",
    "dlabel_active": "Active",
    "dlabel_inactive": "Inactive",
    "dlabel_orientation": "Orientation",
    "dlabel_security_pin": "Security pin",
    "dlabel_start_date": "Start date",
    "dlabel_end_date": "End date",
    "dlabel_form_dis": "Form Display",
    "dlabel_save": "Save",
    "dlabel_cancel": "Cancel",
    "dlabel_template": "Template",
    "dlabel_name": "Name",
    "dlabel_setting": "Setting",
    "dlabel_gnral_setting": "General Setting",
    "dlabel_back": "Back",
    "dmsj_file_exceeds": "the file exceeds 20 megabytes",
    "dmsj_delete_dis": "Delete Display?",
    "dmsj_ar_yu_sr": "Are you sure?",
    "dmsj_delete_it": "Yes, Delete it!",
    "dmsj_greater_than_digits": "it can only be greater than 6 digits.",
    "dmsj_security_pin_empty": "the security pin field cannot be empty, it must have at least 6 digits.",
    "dmsj_send_data": "Send data",
    "dmsj_successful": "Successful",   
    "dmsj_empty_file": "Empty File",    
}